import React from "react";
import { t } from "i18next";
import "../styles/recruiterFeatures.css";

const statusClass = {
  Complete: "wlj-status-chip--ok",
  Incomplete: "wlj-status-chip--warn",
  MissingWeights: "wlj-status-chip--alert",
  WeightageGap: "wlj-status-chip--alert",
};

const statusLabel = {
  Complete: "Recruiter.Complete",
  Incomplete: "Recruiter.Incomplete",
  MissingWeights: "Recruiter.NoWeights",
  WeightageGap: "Recruiter.WeightageGap",
};

const fieldAction = {
  Skills: "skills",
  "Match weights": "weights",
  Salary: "edit",
  Title: "edit",
  Description: "edit",
  Designation: "edit",
  Location: "edit",
  "Job type": "edit",
  "Work location": "edit",
};

export function openJobFix(jobId, field) {
  if (!jobId) return;
  window.dispatchEvent(
    new CustomEvent("wlj-fix-job", {
      detail: { jobId, field: fieldAction[field] || field || "edit" },
    })
  );
}

export default function JobStatusBadges({ item }) {
  const status = item?.completionStatus || item?.CompletionStatus;
  const percent = item?.completionPercent ?? item?.CompletionPercent;
  const hasWeights = item?.hasMatchWeights ?? item?.HasMatchWeights;
  const stale = item?.isStale ?? item?.IsStale;
  const healthy = item?.weightageHealthy ?? item?.WeightageHealthy;
  const jobId = item?.jobId ?? item?.JobId;
  const owned = item?.isOwned ?? item?.IsOwned;
  if (status == null && percent == null && hasWeights == null && !stale) {
    return null;
  }

  const cls = statusClass[status] || "wlj-status-chip--muted";
  const labelKey = statusLabel[status];
  const label = labelKey ? t(labelKey) : status || t("Recruiter.Status");
  const missing = item?.missingFields || item?.MissingFields || [];
  const healthIssues = item?.healthIssues || item?.HealthIssues || [];
  const clickable = owned !== false;

  return (
    <div className="wlj-status-row">
      {percent != null && (
        <span
          className={`wlj-status-chip ${cls} ${clickable && missing.length ? "is-clickable" : ""}`}
          title={
            missing.length
              ? `${t("Recruiter.Missing")}: ${missing.join(", ")}. ${t("Recruiter.ClickToFix")}`
              : t("Recruiter.AllFieldsPresent")
          }
          onClick={() => clickable && missing[0] && openJobFix(jobId, missing[0])}
        >
          {percent}% {label}
        </span>
      )}
      {hasWeights === false && (
        <span
          className={`wlj-status-chip wlj-status-chip--alert ${clickable ? "is-clickable" : ""}`}
          onClick={() => clickable && openJobFix(jobId, "Match weights")}
        >
          {t("Recruiter.SetMatchWeights")}
        </span>
      )}
      {healthy === false && hasWeights !== false && (
        <span
          className={`wlj-status-chip wlj-status-chip--warn ${clickable ? "is-clickable" : ""}`}
          title={healthIssues.join("; ")}
          onClick={() => clickable && openJobFix(jobId, "Match weights")}
        >
          {t("Recruiter.WeightageHealth")}
        </span>
      )}
      {stale && (
        <span className="wlj-status-chip wlj-status-chip--muted" title={t("Recruiter.StaleHint")}>
          {t("Recruiter.Stale")}
        </span>
      )}
      {clickable &&
        missing.map((field) => (
          <span
            key={field}
            className="wlj-status-chip wlj-status-chip--outline is-clickable"
            onClick={() => openJobFix(jobId, field)}
            title={`${t("Recruiter.Fix")} ${field}`}
          >
            {t("Recruiter.Fix")} {field}
          </span>
        ))}
    </div>
  );
}
